import type {
  GetCryptoWalletsParams,
  GetVaspWalletListParams,
  GetWalletManagementParams,
} from '../types/cryptoWalletTypes'

export const cryptoWalletsKeys = {
  all: ['cryptoWallets'] as const,

  lists: () => [...cryptoWalletsKeys.all, 'list'] as const,
  list: (filters: GetCryptoWalletsParams) => [...cryptoWalletsKeys.lists(), filters] as const,

  // VAISP onboarding wallets — a separate endpoint over a separate table, so a
  // separate key subtree. Nested under `all` so a module-wide invalidation still
  // reaches it.
  //
  // `vaspWalletDetails` is a SIBLING of `vaspWalletLists`, not a child: nesting
  // detail under list (as the investors module does) makes every list
  // invalidation silently refetch every open detail, and makes a deliberate
  // three-tree invalidation read as though one of the calls were redundant.
  vaspWalletLists: () => [...cryptoWalletsKeys.all, 'vaspWalletList'] as const,
  vaspWalletList: (filters: Partial<GetVaspWalletListParams>) =>
    [...cryptoWalletsKeys.vaspWalletLists(), filters] as const,

  vaspWalletDetails: () => [...cryptoWalletsKeys.all, 'vaspWalletDetail'] as const,
  vaspWalletDetail: (id: string) => [...cryptoWalletsKeys.vaspWalletDetails(), id] as const,

  vaspWalletStatusCounts: () => [...cryptoWalletsKeys.all, 'vaspWallet', 'statusCounts'] as const,

  // Wallet management — a third view over the same domain, so a third subtree.
  // Detail is a SIBLING of list for the same reason the VAISP trees are: a
  // trustline action has to refetch the open detail AND the table's counts, and
  // nesting one under the other would make that read as a redundant call.
  walletManagementLists: () => [...cryptoWalletsKeys.all, 'walletManagementList'] as const,
  walletManagementList: (filters: Partial<GetWalletManagementParams>) =>
    [...cryptoWalletsKeys.walletManagementLists(), filters] as const,

  walletManagementDetails: () => [...cryptoWalletsKeys.all, 'walletManagementDetail'] as const,
  walletManagementDetail: (investorId: string) =>
    [...cryptoWalletsKeys.walletManagementDetails(), investorId] as const,
}
